angular.module('partnersModule', ['cacheManagerModule'])
    .service('partnersService', ['$q', 'cacheManagerService', partnersService])
    .controller('partnersController', ['$q', '$scope', 'partnersService', partnersController]);